const LayoutSkeleton = () => (
  <div className="flex h-screen bg-background">
    <div className="flex h-full w-52 flex-col border-r border-border bg-card">
      <div className="mb-6 h-8 w-24 animate-pulse rounded bg-muted" />
      <div className="flex flex-col gap-2 px-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="h-9 animate-pulse rounded-md bg-muted" />
        ))}
      </div>
    </div>

    <div className="flex flex-1 flex-col overflow-hidden">
      <div className="flex h-16 items-center justify-between border-b border-border px-4">
        <div className="h-8 w-8 animate-pulse rounded bg-muted lg:hidden" />
        <div className="flex items-center gap-3">
          <div className="h-8 w-8 animate-pulse rounded bg-muted" />
          <div className="h-8 w-8 animate-pulse rounded bg-muted" />
          <div className="h-8 w-8 animate-pulse rounded-full bg-muted" />
        </div>
      </div>

      <main className="flex-1 overflow-auto p-6">
        <div className="space-y-6">
          <div className="h-8 w-64 animate-pulse rounded bg-muted" />
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="h-24 animate-pulse rounded-lg border border-border bg-card" />
            ))}
          </div>
          <div className="space-y-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="h-12 animate-pulse rounded bg-muted" />
            ))}
          </div>
        </div>
      </main>
    </div>
  </div>
);

export default LayoutSkeleton;
